import { round, min } from 'lodash'

export function formatZeros(input: number, digits: number) {
  return round(input, min([((digits - round(input, digits - 2).toString().length)), 0]))
}
